import React, { useState, useEffect } from "react";
import API from "../api";
import { useAuth } from "../context/AuthContext";
import { Form, Button, Alert } from "react-bootstrap";

export default function AdminCalculateHandicapPage() {
  const { user } = useAuth();

  const [weeks, setWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState("");
  const [override, setOverride] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (user?.leagueid) {
      fetchWeeks();
    }
  }, [user]);

  const fetchWeeks = async () => {
    try {
      const res = await API.get(`/league/${user.leagueid}/weeks`);
      setWeeks(res.data);
    } catch (err) {
      console.error("Failed to fetch weeks", err);
    }
  };

  const handleCalculate = async () => {
    if (!selectedWeek) {
      alert("Please select a week.");
      return;
    }

    try {
      const res = await API.post(
        `/league/${user.leagueid}/handicaps/calculate/${selectedWeek}?override=${override}`
      );
      setMessage(res.data.message || "Handicaps calculated.");
    } catch (err) {
      console.error("Failed to calculate handicaps", err);
      setMessage(err.response?.data?.error || "Failed to calculate handicaps.");
    }
  };

  return (
    <div className="container mt-4">
      <h3>Calculate Handicaps</h3>

      {message && <Alert variant="info">{message}</Alert>}

      <Form.Group className="mb-3">
        <Form.Label>Select Next Week</Form.Label>
        <Form.Select
          value={selectedWeek}
          onChange={(e) => setSelectedWeek(e.target.value)}
        >
          <option value="">Select a week...</option>
          {weeks.map((week) => (
            <option key={week.id} value={week.id}>
              Week {week.week_number} - {week.date}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          label="Override existing handicaps"
          checked={override}
          onChange={(e) => setOverride(e.target.checked)}
        />
      </Form.Group>

      <Button variant="primary" onClick={handleCalculate}>
        Calculate Handicaps
      </Button>
    </div>
  );
}
